import {
  faShield,
  faSpinnerThird,
  faShieldCheck,
  faShieldSlash,
} from '@fortawesome/pro-regular-svg-icons'
import { Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Badge, Icon } from '@flecto/ui'

import { type InsurableStatus } from './FormItem'
import classes from './styles.module.css'

type InsuranceBadgeProps = {
  isInsurable: InsurableStatus
  hasRequiredFields: boolean
}

export function InsuranceBadge({
  isInsurable,
  hasRequiredFields,
}: InsuranceBadgeProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'items' })

  if (isInsurable === 'pending' || !hasRequiredFields)
      return null
    
    const badgeConfigs = {
      pending: {
        icon: faShield,
        color: 'gray',
        text: 'insurability_check.pending',
        badgeClass: classes.insuranceBadge,
        iconClass: undefined,
      },
      eligible: {
        icon: faShieldCheck,
        color: 'green',
        text: 'insurability_check.eligible',
        badgeClass: classes.insuranceGreenBadge,
        iconClass: undefined,
      },
      not_eligible: {
        icon: faShieldSlash,
        color: 'gray',
        text: 'insurability_check.not_eligible',
        badgeClass: classes.insuranceBadge,
        iconClass: undefined,
      },
      loading: {
        icon: faSpinnerThird,
        color: 'gray',
        text: 'insurability_check.loading',
        badgeClass: classes.insuranceBadge,
        iconClass: classes.loadingIcon,
      },
    }

  const config = badgeConfigs[isInsurable] || badgeConfigs.pending

  return (
    <Badge
      className={config.badgeClass}
      color={config.color}
      leftSection={
        <Icon
          className={config.iconClass}
          icon={config.icon}
          color={`${config.color}.6`}
          size='sm'
        />
      }
    >
      <Text fz='sm' fw='500' c={`${config.color}.8`}>
        {t(config.text)}
      </Text>
    </Badge>
  )
}
